import React, { useRef, useEffect, useState } from "react";
import { Dimmer, Loader } from "semantic-ui-react";
import iframeCommHub from "@services/IframeCommHub";

const EscalatedReview = () => {
  const iframeRef = useRef(null);
  const [isReady, setIsReady] = useState(false);
  const [hasError, setHasError] = useState(false);
  const timeoutRef = useRef(null);

  const iframeUrl = sessionStorage.getItem("escalated_review_url");
  // const iframeUrl = "http://localhost:5000";
  
  useEffect(() => {
    if (iframeRef.current && iframeUrl) {
      iframeCommHub.setIframeOrigin(new URL(iframeUrl).origin);
      iframeCommHub.initialize(iframeRef.current);
    }

    const unsubscribe = iframeCommHub.on("CONFIG_RECEIVED", () => {
      setIsReady(true);
      setHasError(false);

      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    });

    timeoutRef.current = setTimeout(() => {
      setHasError(true);
      setIsReady(false);
    }, 10000);

    return () => {
      unsubscribe();
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      iframeCommHub.destroy();
    };
  }, [iframeUrl]);

  return (
    <div className="flex-stretch gs-flex-container-vertical height-100" style={{ width: "100%", position: "relative" }}>
      <iframe
        ref={iframeRef}
        src={iframeUrl}
        width="100%"
        height="100%"
        frameBorder="0"
        allowFullScreen
        style={{ border: "none", display: isReady ? "block" : "none" }}
        title="Escalated Review"
      />
      
      {!isReady && !hasError && (
        <Dimmer active inverted>
          <Loader size="large">Loading...</Loader>
        </Dimmer>
      )}
    </div>
  );
};

export default EscalatedReview;

